export const loadedScripts: Record<string, Promise<void> | undefined> = {}

export function loadScript(src: string): Promise<void> {
  if (!src || !src.trim()) {
    return Promise.resolve()
  }

  if (loadedScripts[src]) {
    return loadedScripts[src]
  }

  loadedScripts[src] = new Promise<void>((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve()
      return
    }

    const script = document.createElement("script")
    script.src = src
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
    document.head.appendChild(script)
  })

  return loadedScripts[src]
}
